import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { DayOfWeek, DayTimeSlot } from "src/swagger-gen/web-secured/models";

@Component({
    selector: "app-planning-diffusion-list",
    templateUrl: "./planning-diffusion-list.component.html",
    styleUrls: ["./planning-diffusion-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlanningDiffusionListComponent implements OnInit {
  @Input() planning!: DayTimeSlot[];
  @Input() isEditMode!: boolean;
  @Output() planningUpdated = new EventEmitter<DayTimeSlot[]>();

  DayOfWeek = Object.values(DayOfWeek);
  planningObject!: DayTimeSlot[];

  constructor() {}

  ngOnInit(): void {
    if (this.planning.length > 0) {
      this.planningObject = this.formatPlanningFromAPI();
    } else {
      this.initPlanningObject();
    }
  }

  formatPlanningFromAPI(): DayTimeSlot[] {
    this.initPlanningObject();
    this.planningObject.forEach((element, index) => {
      this.planning.forEach((elementAPI) => {
        if (element.day === elementAPI.day) {
          this.planningObject[index].enable = elementAPI.enable;
          if (elementAPI.timeslots.length > 0) {
            elementAPI.timeslots.forEach((timeSlotAPI, indexTSAPI) => {
              this.planningObject[index].timeslots[indexTSAPI] = timeSlotAPI;
            });
            this.planningObject[index].timeslots.sort(this.compare);
          }
        }
      });
    });
    return this.planningObject;
  }

  compare(a, b) {
    if (a.startTime < b.startTime) {
      return -1;
    }
    if (a.startTime > b.startTime) {
      return 1;
    }
    return 0;
  }

  initPlanningObject() {
    // Structure of planning Object
    this.planningObject = [
      {
        day: DayOfWeek.MONDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.TUESDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.WEDNESDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.THURSDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.FRIDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.SATURDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
      {
        day: DayOfWeek.SUNDAY,
        enable: false,
        timeslots: [
          {
            startTime: null,
            endTime: null,
          },
          {
            startTime: null,
            endTime: null,
          },
        ],
      },
    ];
  }

  changeModel() {
    this.planningUpdated.emit(this.planningObject);
  }
}
